import { gql } from '@apollo/client';

import { OutcomesFragment } from 'approot/shared/graphql/outcomes/outcomes.graphql';

export const ADD_ASSESSMENT_OUTCOME = gql`
  mutation AddAssessmentOutcome($input: AddAssessmentOutcomeInput!) {
    addAssessmentOutcome(input: $input) {
      id
      outcomes {
        ...OutcomesFragment
        description
      }
      performanceExpectations {
        ...OutcomesFragment
        description
      }
    }
  }
  ${OutcomesFragment}
`;

export const DELETE_ASSESSMENT_OUTCOME = gql`
  mutation DeleteAssessmentOutcome($input: DeleteAssessmentOutcomeInput!) {
    deleteAssessmentOutcome(input: $input) {
      id
      outcomes {
        ...OutcomesFragment
        description
        groupLabel
      }
      performanceExpectations {
        ...OutcomesFragment
        description
        groupLabel
      }
    }
  }
  ${OutcomesFragment}
`;

export const AssessmentOutcomesFragment = gql`
  fragment AssessmentOutcomesFragment on Assessment {
    years {
      name
    }
    subjects {
      name
    }
    outcomes {
      ...OutcomesFragment
      description
      groupLabel
    }
    performanceExpectations {
      ...OutcomesFragment
      description
      groupLabel
    }
  }
  ${OutcomesFragment}
`;
